import { Box, Link, Typography } from '@mui/material';
import React, { useContext, useState } from 'react';
import MuiDialogWrapper from '../../components/MuiDialogWrapper/MuiDialogWrapper';
import ReadMorePostContent from '../../../investigate/Content/routes/report/components/InsightsSection/components/PostsInsights/components/PostCard/components/ReadMorePostContent/ReadMorePostContent';
import { getPostActions } from '../../utils/utils';
import { i18n } from '../../i18n/i18n';
import { AddTagIcon, ArrowBackIcon } from '@cellebrite/saas-ui-icons';
import IconButton from '@mui/material/IconButton';
import { COLORS } from '../../constants/constants';
import TagsManager from '../../components/TagsManager/TagsManager';
import Popup from '../../components/Popup/Popup';
import TagsViewer from '../../components/TagsViewer/TagsViewer';
import { GlobalContext } from '../../contexts/globalContext';
import MarkedText from '../../components/MarkedText/MarkedText';
import PostComments from '../../components/PostComments/PostComments';
import PostReactions from '../../components/PostReactions/PostReactions';
import ViewWatchLists from '../../components/ViewWatchLists/ViewWatchLists';
interface CustomDialogProps {
    close: any;
    data: any;
}

const PostDialog: React.FC<CustomDialogProps> = ({ close, data }) => {
    const { reportData } = useContext(GlobalContext);
    const [reactionsClicked, setReactionsClicked] = useState(false);
    const [commentsClicked, setCommentsClicked] = useState(false);
    const [tags, setTags] = useState(data.post.tags || []);

    return (
        <MuiDialogWrapper
            styles={data.styles}
            title={
                reactionsClicked || commentsClicked ? (
                    <Box>
                        <Box
                            sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                            onClick={() => {
                                setReactionsClicked(false);
                                setCommentsClicked(false);
                            }}
                        >
                            <ArrowBackIcon className="fill-b" style={{ marginRight: '12px' }} />
                            <Link sx={{ fontSize: '16px' }}>
                                {i18n.translate(reactionsClicked || commentsClicked ? 'Back to Post' : 'Back to Image')}
                            </Link>
                        </Box>
                        {commentsClicked && (
                            <Typography sx={{ mt: 1 }} className="color-md">
                                {i18n.translate('COMMENTS_LABEL', {
                                    found: data.post.commentsCountData?.collected,
                                    amount: data.post.commentsCountData?.total,
                                })}
                            </Typography>
                        )}
                    </Box>
                ) : (
                    <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 1 }}>
                        {reportData.collection?.taggable && <TagsViewer checkedTags={tags} />}
                        {!!data.post.watchlist?.length && <ViewWatchLists watchLists={data.post.watchlist} />}
                        <MarkedText
                            containerProps={{
                                variant: 's24w500',
                                sx: { '& mark': { backgroundColor: `${COLORS.WARNING_LIGHTEST} !important` } },
                            }}
                            searchText={reportData.find}
                        >
                            {data.post.title}
                        </MarkedText>
                    </Box>
                )
            }
            onClose={() => {
                data.onClose?.(tags);
                close();
            }}
            content={
                <Box>
                    {reactionsClicked ? (
                        <PostReactions
                            post={data.post}
                            styles={{ '& .tab-content': { height: '614px', overflow: 'scroll' } }}
                        />
                    ) : commentsClicked ? (
                        <PostComments post={data.post} />
                    ) : (
                        <ReadMorePostContent
                            post={data.post}
                            onReactionsClick={() => setReactionsClicked(true)}
                            onCommentsClick={(event) => {
                                if (data.post.commentsCountData) {
                                    setCommentsClicked(true);
                                }
                            }}
                        />
                    )}
                </Box>
            }
            prefixCloseWindow={getPostActions(
                data.post,
                null,
                null,
                null,
                reportData.collection?.taggable ? (
                    <Popup
                        actionElement={(handleOpen, anchorRef, open) => {
                            return (
                                <Box sx={{ ml: 0.5, mr: 0.5 }} ref={anchorRef}>
                                    <IconButton
                                        sx={{
                                            'backgroundColor': open ? COLORS.MUTED_DOUBLE_HOVER : null,
                                            '&:hover': {
                                                backgroundColor: COLORS.MUTED_DOUBLE_HOVER,
                                            },
                                        }}
                                        disableRipple
                                        onClick={handleOpen}
                                    >
                                        <AddTagIcon fill={open ? COLORS.BRAND : COLORS.MUTED_DARK} />
                                    </IconButton>
                                </Box>
                            );
                        }}
                        contentElement={(handleClose) => (
                            <Box>
                                <TagsManager
                                    setTags={setTags}
                                    checkedTags={tags}
                                    section={data.section}
                                    elementId={data.post.contentId}
                                />
                            </Box>
                        )}
                    />
                ) : null,
            )}
        />
    );
};

export default PostDialog;
